module.exports = __webpack_public_path__ + "static/media/CC20-AP080-12.318b1bfc.png";